"use client";

import { useRef } from "react";
import { Loader } from "@/components/common/loader";
import { SectionHero } from "@/components/common/section-hero";
import { useCartStore } from "@/features/cart/components";
import { CartPricing } from "@/features/cart/components/cart/cart-pricing";
import { CheckoutBar } from "@/features/cart/components/cart/checkout-bar";
import { CartFaq } from "@/features/cart/components/cart-faq";
import { CartList } from "@/features/cart/components/cart-list";
import { PendingRemovalsProvider } from "@/features/cart/components/pending-removals-provider";
import { usePopulateAbandonedCart } from "@/features/cart/hooks/use-populate-abandoned-cart";
import { DiscountCartProgress } from "@/features/discounts/components/progress/discount-cart-progress";

export const CartPage = () => {
  const cartStore = useCartStore((state) => state);
  const { isCartPopulating } = usePopulateAbandonedCart();

  const pricingRef = useRef<HTMLDivElement>(null);

  const isCartEmpty = cartStore.items?.length === 0;
  return (
    <PendingRemovalsProvider>
      {" "}
      <div className="container relative max-md:p-0">
        <div className="flex flex-col lg:flex-row lg:gap-10">
          <div className="min-w-0 flex-1">
            <SectionHero>
              {isCartPopulating ? (
                <div className="flex h-full items-center justify-center">
                  <Loader />
                </div>
              ) : (
                <CartList />
              )}
            </SectionHero>
            <CartFaq className="max-lg:hidden" />
          </div>

          {!isCartEmpty && (
            <div
              className="sticky top-28 flex flex-1 flex-col gap-4 max-md:container lg:w-76 lg:flex-none lg:self-start"
              id="cart-price"
              ref={pricingRef}
            >
              <CartPricing />
              <DiscountCartProgress className="order-1 md:order-2" />
            </div>
          )}
        </div>
      </div>
      {!isCartEmpty && <CheckoutBar pricingRef={pricingRef} />}
      <CartFaq className="lg:hidden" />
    </PendingRemovalsProvider>
  );
};
